import { SearchLandingContext } from '@/context/SearchLandingContext';
import React, { useContext } from 'react';
import {RotateCcw} from 'react-feather'

const RecentlySearched = ({clickSearchTerm}:{clickSearchTerm:(text: string) => void}) => {

    const { lastSearches, clearSearchHistory } = useContext(SearchLandingContext)

    return (
        <div className='recently-searched'>
            <div className='title-wrapper'>
                <h3 className='recent-search-title'>Recently Searched</h3>
                <button className='recent-search-clear-all' onClick={clearSearchHistory}>Clear All</button>
            </div>
            {lastSearches.length
            ?  <ul className='recent-search-terms'>
                {lastSearches.map((term, idx) => 
                <li className='term' key={`st-${term}-${idx}`}>
                    <button className='term-wrapper' onClick={() => clickSearchTerm(term)}>
                        <RotateCcw size={12} color={'#9EA8BA'} style={{marginRight: '5px'}}/> {term}
                    </button>
                </li>)}
            </ul>
            :
            <span className='no-recent-searches'>No recent searches</span>
            }
           
        </div>
    )
}

export default RecentlySearched;